import { render } from "./Mb021.vue?vue&type=template&id=a613465a"
import script from "./Mb021.vue?vue&type=script&lang=js"
export * from "./Mb021.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__